import React from 'react';
import {
  ComponentParams,
  ComponentRendering,
  Placeholder,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { RightRailLayout } from '@ahc-digital/component-library';

interface RightRailSublayoutProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
}

export const Default = (props?: RightRailSublayoutProps): JSX.Element => {
  const id = props?.params?.RenderingIdentifier;

  if (!props?.rendering) {
    return <></>;
  }

  return (
    <RightRailLayout
      id={id}
      aboveRightRailSection={
        <Placeholder name="above-right-rail-section" rendering={props.rendering} />
      }
      breadcrumbsSection={<Placeholder name="breadcrumb-section" rendering={props.rendering} />}
      rightRailBodyContent={
        <Placeholder name="right-rail-body-content" rendering={props.rendering} />
      }
      rightRailContent={<Placeholder name="right-rail-content" rendering={props.rendering} />}
      belowRightRailSection={
        <Placeholder name="below-right-rail-section" rendering={props.rendering} />
      }
    />
  );
};
